// Module
var code = `<form name="\$ctrl.form">
<div>
  <table class="table">
    <h2 class="section-header">Co-makers</h2>
    <thead>
    <tr>
      <th class="numbers">No.</th>
      <th>Name</th>
      <th>Birth Date</th>
      <th>Customer Number</th>
      <th>Mother Branch</th>
      <th>Active loans</th>
      <th>Loans as co-maker</th>
      <th>Limit</th>
      <th>Type</th>
      <th ng-if="\$ctrl.editMode"></th>
      <th ng-if="\$ctrl.editMode"></th>
    </tr>
    </thead>
    <tbody class="tbody">
    <tr ng-repeat="coMaker in \$ctrl.coMakerDetails">
      <td>{{\$index + 1}}.</td>
      <td class="label">
        {{coMaker.effectiveName}}
      </td>
      <td class="label">
        {{coMaker.birthDate | prettyDate}}
      </td>
      <td class="label">
        {{coMaker.customerNumber}}
      </td>
      <td class="label">
        {{coMaker.branchName}}
      </td>
      <td class="label">
        {{coMaker.activeLoans}} active loan{{coMaker.activeLoans !== 1 ? 's' : ''}}
      </td>
      <td class="label">
        {{coMaker.numberOfCoMadeLoans}} loan{{coMaker.numberOfCoMadeLoans !== 1 ? 's' : ''}}
      </td>
      <td >
        {{coMaker.maxComakerTagLimit}}
      </td>
      <td class="label">
        <select
          ng-options="type.id as type.description for type in \$ctrl.dict.LOAN_CO_MAKER_TYPE"
          ng-model="coMaker.typeId"
          ng-change="\$ctrl.coMakerTypeChanged(coMaker)"
          ng-disabled="!\$ctrl.editMode"
          required>
        </select>
      </td>
      <td class="label" ng-if="\$ctrl.editMode && \$ctrl.hasReachedComakerLimit(coMaker)">
        <validator condition="!\$ctrl.hasReachedComakerLimit(coMaker)"></validator>
        <div class="alert alert--danger">
          This customer has already reached its max Co-maker limit and can only be added as a Co-borrower.
        </div>
      </td>
      <td class="buttons" ng-if="\$ctrl.editMode">
        <button type="button"
                class="btn btn-danger"
                ng-click="\$ctrl.removeCoMaker(coMaker)">Remove
        </button>
      </td>
    </tr>
    <tr ng-if="\$ctrl.editMode">
      <td>{{\$ctrl.coMakerDetails.length + 1}}.</td>
      <td colspan="8">
        <customer-picker
          on-choose="\$ctrl.addCoMaker(customer)"
        ></customer-picker>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/details/co-makers/customer-loan-co-makers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;